import angular, { IScope } from 'angular';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import uiRouter, { StateService, StateParams } from '@uirouter/angularjs';
import { WrappedACMEErrorResponse, UIBModalService, ACMEListResponse, TODO } from '@b2b/types/core';
import { MembershipLifecycleActionForm } from '@b2b/types/membership';

class MembershipFormsController {
  static $inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$uibModal',
    'NoticeFactory',
    'ApiService',
    'MembershipLifecycleActionFormListData',
  ];

  notice = new this.noticeFactory();

  membershipLifecycleActionFormList: MembershipLifecycleActionForm[] = [];

  constructor(
    private $scope: IScope & { membershipForms: TODO },
    private $state: StateService,
    private $stateParams: StateParams,
    private $uibModal: UIBModalService,
    private noticeFactory: NoticeFactory,
    private apiService: ApiService,
    private MembershipLifecycleActionFormListData: { data: ACMEListResponse<MembershipLifecycleActionForm> }
  ) {
    this.$scope.membershipForms = this;
  }

  $onInit() {
    this.$scope.$emit('Application::contentTitleChange', {
      title: 'Membership Forms',
      buttonLeft: {
        label: 'Close',
        action: () => {
          this.close();
        },
      },
      buttonRight: {
        label: '+ Add Form',
        action: () => {
          this.addForm();
        },
      },
    });

    if (this.MembershipLifecycleActionFormListData && this.MembershipLifecycleActionFormListData.data.success) {
      const lifeCycleAction = this.$stateParams.action;
      this.membershipLifecycleActionFormList = this.MembershipLifecycleActionFormListData.data.payload.list.filter(
        (form) => {
          return form.lifecycleAction === lifeCycleAction;
        }
      );
    }
  }

  close() {
    this.$state.go(
      'application.membership.rules.lifecycle',
      {},
      {
        notify: true,
        reload: true,
        inherit: false,
      }
    );
  }

  addForm() {
    this.$state.go('application.membership.forms.create');
  }

  removeForm(membershipLifecycleActionForm: TODO) {
    this.notice.hideMessages();
    
    const cancelModal = this.$uibModal.open({
      size: 'md',
      controller: 'ConfirmModalController',
      templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
      resolve: {
        modalTitle: function () {
          return 'Delete form mapping';
        },
        okText: function () {
          return 'Delete';
        },
        modalMessage: function () {
          return 'You are about to delete this form mapping. Are you sure?';
        },
      },
    });

    cancelModal.result.then(() => {
      this.apiService.membership.lifecycle.forms
        .remove(membershipLifecycleActionForm)
        .then(() => {
          this.notice.showSuccessMessages(
            [
              {
                message: 'Successfully removed!',
              },
            ],
            {
              duration: 3000,
            }
          );
          const deletedFormIndex = this.membershipLifecycleActionFormList.findIndex(
            (item) => item.id === membershipLifecycleActionForm.id
          );
          this.membershipLifecycleActionFormList.splice(deletedFormIndex, 1);
        })
        .catch(this.onAPICallError.bind(this));
    });
  }

  hasForms() {
    return !!this.membershipLifecycleActionFormList.length;
  }

  changeMembershipForm(membershipLifecycleActionForm) {
    this.$state.go('application.membership.forms.edit', { id: membershipLifecycleActionForm.id });
  }

  onAPICallError(response: { data: WrappedACMEErrorResponse }) {
    this.notice.showErrorMessages([{ message: response.data.error }]);
  }
}

export const MembershipFormsModule = angular
  .module('acme.view.application.membership.forms.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.factory.notice',
    'acme.common.service.api',
    'acme.view.application.modals.confirm.controllers',
  ])
  .controller('MembershipFormsController', MembershipFormsController).name;
